// extracted by mini-css-extract-plugin
export var scrollArea = "_pk-0";